import React from 'react';
import { SvgIcon } from '@material-ui/core';

const FileUploaded = (props) => (
  <SvgIcon
    width="88.335"
    height="114.035"
    viewBox="0 0 88.335 114.035"
    {...props}
  >
    <path
      data-name="Tracé 4609"
      d="M241.577 459.583a2.2 2.2 0 0 0-2.2 2.208l.084 22.35a2.2 2.2 0 0 0 3.872 1.426l19.159-22.349a2.2 2.2 0 0 0-1.672-3.635z"
      transform="translate(-184.89 -372.304)"
    />
    <path
      data-name="Tracé 4610"
      d="M210.648 395.008a1.275 1.275 0 0 1 1.277 1.274v2.318a1.276 1.276 0 0 1-1.277 1.274h-44.623a1.274 1.274 0 0 1-1.274-1.274v-2.315a1.273 1.273 0 0 1 1.274-1.274zm1.277 13.153a1.275 1.275 0 0 1-1.277 1.274h-44.623a1.273 1.273 0 0 1-1.274-1.274v-2.315a1.273 1.273 0 0 1 1.274-1.274h44.623a1.276 1.276 0 0 1 1.277 1.274v2.315zm-40.69-21.795a1.085 1.085 0 0 1 1.085-1.084h32.035a1.085 1.085 0 0 1 1.084 1.084v2.7a1.085 1.085 0 0 1-1.084 1.084H172.32a1.085 1.085 0 0 1-1.085-1.084v-2.7zm-17.773-23.1a3.465 3.465 0 0 0-3.462 3.463v76.894a3.465 3.465 0 0 0 3.462 3.465h46.268a7.144 7.144 0 0 1-.023-.527l-.084-22.349a7.061 7.061 0 0 1 7.064-7.092h19.502V391.2h-11.734a6.223 6.223 0 0 1-6.215-6.215v-6.474a6.223 6.223 0 0 1 6.215-6.215h3.881l-5.212-9.03z"
      transform="translate(-150 -334.704)"
    />
    <path
      data-name="Tracé 4611"
      d="M270.223 316.416h-5.651c-.863 0-1.565 1.071-1.565 2.393v18.342h-4.174a1.585 1.585 0 0 0-1.373 2.378l8.751 15.159a1.585 1.585 0 0 0 2.748 0l8.752-15.159a1.586 1.586 0 0 0-1.373-2.378h-4.549v-18.342c0-1.322-.7-2.393-1.566-2.393z"
      transform="translate(-191.865 -316.416)"
    />
    <path
      data-name="Tracé 4612"
      d="M278.742 393.879v-6.474a1.35 1.35 0 0 0-1.35-1.352h-22.53a1.352 1.352 0 0 0-1.352 1.352v6.474a1.352 1.352 0 0 0 1.352 1.352h22.53a1.35 1.35 0 0 0 1.35-1.352z"
      transform="translate(-190.407 -343.6)"
    />
  </SvgIcon>
);

export default FileUploaded;
